import React from 'react';
import _ from 'lodash';

import { keyColumnsByName } from './useTableState';

export const useSavedSettings = (domain: any, columnConfig: any) => {
  const rawStore = localStorage.getItem(`cowbell`);
  const store = JSON.parse(rawStore);

  const slice = React.useMemo(
    () => _.get(store, `uiSettings.${domain}`, {}),
    [domain, store]
  );

  // Keyed by column name in both branches. The saved slice is written name-keyed
  // (useUiSettingsAutosave), so returning the raw config -- keyed by whatever the author
  // called each entry -- handed useTableState two namespaces to reconcile, and columns whose
  // key and `name` are spelled differently fell between them.
  const definedColumns = React.useMemo(
    () => keyColumnsByName(columnConfig),
    [columnConfig]
  );

  const reconciledColumns = React.useMemo(
    () =>
      _.mapValues(definedColumns, (col: any) => {
        const saved = _.get(slice, ['columns', col.name]);
        const show = saved != null ? saved.show !== false : col.show !== false;
        return { ...col, show };
      }),
    [definedColumns, slice]
  );

  const saveSetting = React.useCallback(
    (update: any) => {
      localStorage.setItem(
        `cowbell`,
        JSON.stringify({
          ...store,
          uiSettings: {
            ...store.uiSettings,
            [domain]: { ...slice, ...update },
          },
        })
      );
    },
    [domain, slice, store]
  );

  return { uiSettings: { ...slice, columns: reconciledColumns }, saveSetting };
};
